// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__wBSH7","filesListContainer":"PosDisputesFiles_filesListContainer__weS9r","filesButton":"PosDisputesFiles_filesButton__37eqd"};